import { Button, Dialog, Flex, Portal, Text } from '@welbe/design-system';
import { tokens } from '@welbe/web-design-system';
import { FiInfo } from 'react-icons/fi';

export const ModalDisabledFeat = ({ onClose }: { onClose: () => void }) => {
	return (
		<Dialog.Root color={tokens.color_gray_dark} lazyMount open={true}>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content
						backgroundColor="gray.100"
						animation="slideIn"
						width={{ base: 'full', md: '700px' }}
					>
						<Dialog.Header
							padding="1.5rem"
							paddingBottom="1rem"
							borderBottom="1px solid"
							borderColor="gray.200"
						>
							<Flex gap={3} align="center">
								<Flex
									justify="center"
									align="center"
									bg="blue.500"
									borderRadius="md"
									width="40px"
									height="40px"
									flexShrink={0}
								>
									<FiInfo size={20} color="white" />
								</Flex>
								<Flex direction="column" gap={1}>
									<Dialog.Title
										fontSize="1.25rem"
										fontWeight="700"
										color="blue.500"
										width="100%"
									>
										Funcionalidad indisponible
									</Dialog.Title>
								</Flex>
							</Flex>
						</Dialog.Header>
						<Dialog.Body padding="1.5rem">
							<Text>
								¡Ups! Esta funcionalidad no está disponible por el momento. Si
								necesitas acceso a la funcionalidad, contácta a nuestro equipo
								de soporte.
							</Text>
						</Dialog.Body>
						<Dialog.Footer
							padding="1.5rem"
							borderTop="1px solid"
							borderColor="gray.200"
						>
							<Flex justify="center" width="100%">
								<Button onClick={onClose}>Entendido</Button>
							</Flex>
						</Dialog.Footer>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
